import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { stats } from "../../mock";

const points = [
  "Diamond-blade sawing for clean, chip-free edges",
  "Dust & slurry managed \u2014 no mess left behind",
  "Depth-controlled cuts that protect services below",
  "One owner-operator, start to finish \u2014 no subbies",
];

export default function About() {
  return (
    <section id="about" className="relative bg-brand-ink text-brand-cream py-16 sm:py-24">
      <div className="grain absolute inset-0" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        {/* Inline intro row */}
        <div className="grid gap-8 lg:grid-cols-12 lg:gap-12 lg:items-end">
          <div className="lg:col-span-6">
            <span className="reveal kicker text-brand-teal">Why Max?</span>
            <h2 className="reveal mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.03] text-white">
              A sharper standard for concrete cutting.
            </h2>
          </div>
          <div className="lg:col-span-6">
            <p className="reveal text-white/65 leading-relaxed">
              Max built this business on one idea. A concrete cut should be
              exact, tidy and done when he says it will be. From a single core hole to a
              full driveway break-out, you get the same careful, measured approach and a
              finish you&rsquo;d be happy to show off. No call-out fees, no minimum job.
            </p>
          </div>
        </div>

        {/* Inline feature row */}
        <ul className="reveal mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {points.map((p) => (
            <li key={p} className="flex items-start gap-3 rounded-xl border border-white/10 bg-white/[0.04] p-4">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-teal/20">
                <Check className="h-3.5 w-3.5 text-brand-teal" strokeWidth={3} />
              </span>
              <span className="text-sm font-medium text-white/80">{p}</span>
            </li>
          ))}
        </ul>

        {/* Stats band */}
        <div className="reveal mt-10 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="bg-brand-ink px-6 py-7 text-center">
              <p className="font-display text-3xl sm:text-4xl font-semibold text-white">{s.value}</p>
              <p className="mt-1 text-xs uppercase tracking-[0.15em] text-white/45">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="reveal mt-10 flex justify-center">
          <Link to="/quote" className="group inline-flex items-center gap-2 rounded-full bg-brand-teal px-7 py-4 text-sm font-semibold text-white transition-all duration-300 hover:bg-white hover:text-brand-ink">
            Start your project
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>
  );
}
